import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedLongFormInstructions,
  BackendMutationExtractLongFormInstructionsFromPdfArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractLongFormInstructionsFromPdf($projectId: ID, $sectionId: ID!, $documentId: ID!) {
    extractLongFormInstructionsFromPdf(
      projectId: $projectId
      sectionId: $sectionId
      documentId: $documentId
    ) {
      instructions
      status
      extractionErrors
    }
  }
`;

type Variables = Pick<
  BackendMutationExtractLongFormInstructionsFromPdfArgs,
  'projectId' | 'sectionId' | 'documentId'
>;
type Result = BackendExtractedLongFormInstructions;

export const extractLongFormInstructionsFromPdf = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
